enum DiscoveredVia {
    PeerRecommendation = 'Peer recommendation',
    TrustpilotG2orCapterra = 'Trustpilot, G2 or Capterra',
    GoogleSearchEngine = 'Google / Search engine',
    YouTube = 'YouTube',
    TV = 'TV',
    OutdoorAdvertising = 'Outdoor advertising',
    SocialMedia = 'Social Media',
    Press = 'Press',
}

export default DiscoveredVia
